<template>
  <div class="">
    <div v-if="!isChildren && $route.meta.type == 'plans'" class="row-height">
      <Header
        :title="'Health Plans'"
        :searchInput="true"
        :exportButton="true"
        :placeholder="'Search Plans'"
        :newButton="true"
        @invite="invite"
        @export="exportData"
        @add="add"
        @searchInput="searchInput"
      ></Header>
      <div class="mt-3">
        <v-simple-table
          fixed-header
          id="tblData"
          height="70vh"
          class="no-padding tr-custom-height"
        >
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-left">NAME</th>
                <th class="text-left">PLAN ID</th>
                <th class="text-left">PLAN TYPE</th>
                <th class="text-left">GROUP ID</th>
                <th class="text-left">ADMIN/TPA</th>
                <th class="text-left">STATUS</th>
              </tr>
            </thead>
            <tbody
              v-if="items.length > 0 && !filterItems"
              class="text-gray tr-custom-height"
            >
              <tr v-for="(item, index) in items" :key="index">
                <td v-if="item.name" @click="showClient(item)">
                  <a>{{ item.name }}</a>
                </td>
                <td v-else><a>/</a></td>
                <td v-html="item.planId ? item.planId : '/'"></td>
                <td v-html="item.type ? item.type : '/'"></td>
                <td v-html="item.groupId ? item.groupId : '/'"></td>
                <td v-html="item.admin ? item.admin : '/'"></td>
                <td
                  v-html="
                    item.status
                      ? item.status.charAt(0).toUpperCase() +
                        item.status.slice(1)
                      : '/'
                  "
                ></td>
              </tr>
            </tbody>
            <tbody v-else-if="items.length < 1 && filterItems">
              <v-col md="12" cols="12">
                <v-alert
                  border="bottom"
                  colored-border
                  type="warning"
                  elevation="2"
                  class="text-gray"
                >
                  Sorry! No results found
                </v-alert>
              </v-col>
            </tbody>
            <tbody v-else>
              <v-col md="12">
                There are no plans currently added to this account.
                <a @click="add"> Click to add plans to your client’s account</a>
              </v-col>
            </tbody>
          </template>
        </v-simple-table>
      </div>
    </div>
    <router-view></router-view>
  </div>
</template>
<script>
import Header from "../../../Layout/HeaderPage.vue";
import api from "../../../../../../services/api";
import successModal from "../../../../../TablesTemplate/SuccessDialog.vue";
import errorModal from "../../../../../TablesTemplate/ErrorDialog.vue";
export default {
  components: { errorModal, successModal },
  data() {
    return {
      showDetails: false,
      tab: "solution",
      dialog: false,
      items: [],

      singleItem: null,
      typeItems: [{ text: "Categories", value: "Categories" }],
      sortItems: [{ text: "Newest", value: "Newest" }],
      sortBy: "",
      type: "",
      solutions: [],
      favorites: [],
      filterArray: [],
      filterItems: false,
    };
  },
  components: {
    Header,
  },
  computed: {
    isChildren() {
      let bool = false;
      if (this.$route.meta && this.$route.meta.isChildren) {
        bool = true;
      }
      return bool;
    },
  },
  created() {
    this.getData();
  },
  methods: {
    exportData() {
      var elt = document.getElementById("tblData");
      var downloadLink;
      var dataType = "application/vnd.ms-excel";
      var tableSelect = elt;
      var tableHTML = tableSelect.outerHTML.replace(/ /g, "%20");

      // Specify file name
      let filename = "excel_data.xls";

      // Create download link element
      downloadLink = document.createElement("a");

      document.body.appendChild(downloadLink);

      if (navigator.msSaveOrOpenBlob) {
        var blob = new Blob(["\ufeff", tableHTML], {
          type: dataType,
        });
        navigator.msSaveOrOpenBlob(blob, filename);
      } else {
        // Create a link to the file
        downloadLink.href = "data:" + dataType + ", " + tableHTML;

        // Setting the file name
        downloadLink.download = filename;

        //triggering the function
        downloadLink.click();
      }
    },
    getData() {
      api()
        .get(`/tpas/clients/${this.$route.params.id}/plans`)
        .then((res) => {
          if (res) {
            this.items = res.data;
            this.filterArray = this.items;
          }
        });
    },
    invite() {},
    add() {
      this.$router.push(
        "/digital-invoicing/clients/plans/" + this.$route.params.id + "/add-new"
      );
    },
    searchInput(val) {
      this.items = this.filterArray.filter((el) => {
        if (el.name.toString().toLowerCase().includes(val.toLowerCase())) {
          return el.name.toString().toLowerCase().includes(val.toLowerCase());
        }
      });
      if (this.items.length < 1) {
        this.filterItems = true;
      } else {
        this.filterItems = false;
      }
    },
    showClient(item) {
      this.singleItem = item;
      this.$store.commit("setSingleItem", item);
      this.$router.push(
        "/digital-invoicing/clients/plans/" + this.$route.params.id + "/details"
      );
    },

    searchMembers() {},
  },
};
</script>
<style>
.border-blue-bottom {
  border-bottom: 6px solid #4072b7;
  margin-left: -1px;
  margin-right: -2px;
  margin-top: -1px;
}

.tr-custom-height > .v-data-table__wrapper > table > tbody > tr > td {
  height: 75px;
}
</style>